module.exports = __webpack_public_path__ + "static/media/terumi_wakiyama_portray.7ed47809.jpg";